import axios from 'axios'

class PostRepository {
  get (page, category, month, year) {
    return axios.get(`${BASE_URL}/posts`, {
      params: {
        page: page,
        category: category,
        month: month,
        year: year
      }
    })
    .then(response => {
      return response.data
    })
  }
}

export default new PostRepository()



// WEBPACK FOOTER //
// ./src/data/post.repository.js